import type { RootState } from "../types/store.types";

export const selectShowDevPanel = (state: RootState) => state.devTools.showPanel;
export const selectLogQueries = (state: RootState) => state.devTools.logQueries;
export const selectLoggingItems = (state: RootState) => state.devTools.loggingItems;
